import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

const defaultState = {};

const extractId = x => x.__id;

function TARGETS_SET(state, action) {
	const { targets } = action;
	if (targets.length === 0) {
		return state;
	}

	const nextState = { ...state };
	targets.forEach(t => {
		const forms = t.tabs.map(tab => ({
			title: tab.label,
			icon: tab.icon_name,
			profile: tab.profile,
			criteriaNames: tab.criteria,
		}));

		const target = {
			...t,
			fieldIds: t.fields.map(extractId),
			joinpathIds: t.joinpaths.map(extractId),
			forms,
		};

		delete target.fields;
		delete target.joinpaths;
		delete target.tabs;

		nextState[target.name] = target;
	});

	return nextState;
}

function TARGETS_RESET() {
	return defaultState;
}

const handlers = {};
handlers[actionTypes.TARGETS_SET] = TARGETS_SET;
handlers[actionTypes.TARGETS_RESET] = TARGETS_RESET;
export default createReducer(defaultState, handlers);
